import React, { FC, useMemo, useState } from 'react';

import LoadingDisplay from '@nhl/nhl-react-ui/lib/LoadingDisplay';
import ReactTable from '@nhl/nhl-react-ui/lib/NhlTable/ReactTable';

import '../../../styles/common/react-table.scss';
import { CoachRecord } from '../../../types/CoachTypes';
import { GeneralManagerRecord } from '../../../types/GeneralManagerTypes';
import { OutdoorGameSkaterStats, OutdoorGameGoalieStats } from '../../../types/OutdoorGameStatsTypes';
import { Sort } from '../../../types/ReactTableTypes';
import TableLayout from '../tableLayout';
import VideoModal from '../videoModal';

import './styles.scss';

const sortAggregatedRows = (aggregateSortingKey) => (aggregatedRows) => {
    // If the cell isExpanded, we will sort the pivoted rows by startSeason
    return aggregatedRows.sort((a, b) => {
        return a.original[aggregateSortingKey] - b.original[aggregateSortingKey];
    });
};

type Props = {
    aggregateSortingKey?: string;
    getColumns: (setVideoId: React.Dispatch<any>) => any[] | [];
    isLoading: boolean;
    pivotBy?: string;
    records: CoachRecord[] | GeneralManagerRecord[] | OutdoorGameSkaterStats[] | OutdoorGameGoalieStats[];
    sortedState: Sort[];
    templateKey?: string;
    title: string;
};

const RegistryRecords: FC<Props> = ({
    aggregateSortingKey = 'startSeason',
    getColumns,
    isLoading,
    pivotBy,
    records,
    sortedState,
    templateKey,
    title,
}) => {
    const [videoId, setVideoId] = useState(null);

    const defaultPageSize = 50;
    const showPagination = records.length > defaultPageSize;
    return (
        <LoadingDisplay isLoading={isLoading}>
            <div className="registry-career-container">
                <VideoModal
                    videoId={videoId}
                    closeVideoModal={() => {
                        setVideoId(null);
                    }}
                />
                <TableLayout templateKey={templateKey} header={title}>
                    <ReactTable
                        className="table-layout-table -striped -highlight"
                        data={records}
                        columns={useMemo(() => getColumns(setVideoId), [])}
                        defaultPageSize={defaultPageSize}
                        showPagination={showPagination}
                        resizable={false}
                        pivotBy={pivotBy && useMemo(() => [pivotBy], [])}
                        sortAggregatedRows={sortAggregatedRows(aggregateSortingKey)}
                        defaultSorted={sortedState}
                    />
                </TableLayout>
            </div>
        </LoadingDisplay>
    );
};

export default React.memo(RegistryRecords);
